import axios from 'axios';
import AuthService from '../components/services/auth.service';

// Add response interceptor to handle auth and subscription errors globally
axios.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response) {
      const status = error.response.status;
      const currentPath = window.location.pathname;
      const requestUrl = error.config?.url || '';

      if (status === 401) {
        // Don't logout for non-auth endpoints (e.g. profile picture)
        const skipLogoutUrls = ['/api/users/profile-picture'];
        const shouldSkipLogout = skipLogoutUrls.some(url => requestUrl.includes(url));

        if (!shouldSkipLogout) {
          // Unauthorized - redirect to login page
          console.log('Unauthorized - redirecting to login page');
          AuthService.logout();
          // logout() already handles redirect via window.location.reload()
        }
      } else if (status === 402) {
        // Payment required - redirect to payment page (but not if already on payment page)
        const paymentRoutes = ['/payment', '/payment-success', '/payment-cancelled'];
        
        if (!paymentRoutes.includes(currentPath)) {
          console.log('Payment required - redirecting to payment page');
          window.location.href = '/payment';
        } else {
          console.log('Payment required but already on payment page');
        }
      }
    }
    return Promise.reject(error);
  }
);

export default axios;
